export default __webpack_public_path__ + "static/media/OneClick.89f6c607.svg";